import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createVNode("div", { class: "card-header-title" }, [
    /*#__PURE__*/_createVNode("p", { class: "title is-4" }, "Informationen zur Abholung")
  ])
], -1)
const _hoisted_3 = { class: "card-content" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "subtitle is-6" }, "Bei Abholung der Ware an unserem Lager ist folgendes zu beachten:", -1)
const _hoisted_5 = {
  key: 0,
  class: "content"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("ul", null, [
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Ihre Sendung Erhalten Sie bei: "),
    /*#__PURE__*/_createVNode("pre", null, "Langhorst Logistic GmbH\n\n28197 Bremen\nLudwig-Erhard-Str. 12\n\nTel.: 0421-52166-311\nFax.: 0421-52166-340\nE-Mail: import@langhorst.de\n\nAbnahmezeit: 7.00 bis 16.00 Uhr\n              ")
  ]),
  /*#__PURE__*/_createVNode("li", null, "Bitte Sendungsverfügbarkeit vor Abnahme prüfen. Die Sendung ist abnahmebereit, sobald im linken Fenster eine ATB Position angezeigt wird. Eine Anmeldung zur Abholung ist nicht notwendig."),
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Zuständiges Zollamt: "),
    /*#__PURE__*/_createVNode("pre", null, "Zollamt Bremen\nDiensstellennummer: 2325\nDienstort Senator-Harmssen-Straße 5\n\n28197 Bremen\n\nTel. (04 21) 3897-2600\n            ")
  ]),
  /*#__PURE__*/_createVNode("li", null, "Bei Abholung mit ATC- oder ATD-Nummern ist zwingend der Steuerbescheid oder der Atlasausdruck vorzulegen aus dem klar zu erkennen ist, ob eine Beschau angeordnet wurde."),
  /*#__PURE__*/_createVNode("li", null, "Bei Abholung mit NCTS-Verfahren ist die Ware zwingend dem Zollamt zu gestellen.")
], -1)
const _hoisted_7 = {
  key: 1,
  class: "content"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createVNode("li", null, "Bitte beachten Sie, dass wir Sendungen nur ausliefern, sofern unsere Verwahrung nachweislich beendet wurde. Anderenfalls erhält Ihr Fahrer die Ware nicht!", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: "subtitle is-6" }, "Für Kosten jeder Art, welche durch falsche oder fehlende Eingaben bzw. durch die Verwendung einer falschen ATB Nr. verursacht werden, haftet ausschließlich der Verursacher!", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      (_ctx.cfs === 'LANGDEBRE1')
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _hoisted_6
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode("ul", null, [
              (_ctx.cfs === 'WVMKDECOL2')
                ? (_openBlock(), _createBlock("li", _hoisted_8, "Zuständiges Zollamt ist Zollamt Köln-West, Dienststellenmummer 7202"))
                : _createCommentVNode("", true),
              (_ctx.cfs === 'KUEHDEBFE1')
                ? (_openBlock(), _createBlock("li", _hoisted_9, "Zuständiges Zollamt ist Zollamt Eckendorfer Straße in Bielefeld, Dienststellennummer 8001"))
                : _createCommentVNode("", true),
              _hoisted_10
            ]),
            _hoisted_11
          ]))
    ])
  ]))
}